export default __webpack_public_path__ + "static/media/phoneWhatsapp.ed2248f8.png";